import { useContext } from "react";
import { PwaInstallContext } from "../context/pwa-install-provider";

/**
 * Returns the shared PWA installation state for mobile UI surfaces.
 */
export const usePwaInstall = () => {
  return useContext(PwaInstallContext);
};